<template>
  <div class="co-flex-col">
    <v-card
      class="overflow-y-auto overflow-x-hidden white rouned px-8 py-6"
      flat
      height="610"
    >
      <div
        class="co-flex-row co-justify-center co-items-center mb-4"
      >
        <v-btn
          :loading="btnMore.loading"
          plain
          :style="loadStates[btnMore.state]"
        >
          {{ loadTexts[btnMore.state] || '查看更多信息' }}
        </v-btn>
      </div>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="co-flex-col"
      >
        <template v-if="item.toId === fromUser.userId">
          <message-im-content
            :data="item"
          />
        </template>
        <template v-else>
          <message-im-content
            :data="item"
            back-color="blue"
            fore-color="white"
            reversed
          />
        </template>
      </div>
    </v-card>

    <v-card
      class="rounded pa-4 mt-4"
      flat
      tile
      color="white"
    >
      <div class="co-flex-row co-items-center co-w-full">
        <v-avatar
          size="56"
        >
          <v-img
            :src="fromUser.avatar"
            cover
          />
        </v-avatar>
        <v-text-field
          v-model="msg"
          :label="msgLabel"
          outlined
          hide-details
          class="mx-4"
        />
        <v-btn
          :loading="btnSend.loading"
          color="primary"
          height="56"
          :width="btnSend.width"
          @click="onSend"
        >
          {{ btnSend.text }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import api from '@/api/co.api'
  import user from '@/api/co.user'
  import web from '@/api/web/co.web'
  import socket from '@/api/co.socket'
  import { EventBus } from '@/api/co.event';

  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'
  import 'dayjs/locale/zh-cn'
  import app from "@/api/co.app";

  dayjs.locale('zh-cn')
  dayjs.extend(relativeTime)

  let avatar = require('@/assets/profile-avatar.png');
  let avatar2 = require('@/assets/avatar.png');

  export default {
    components: {
      MessageImContent: () => import('@/pages/sections/my/MessageImContent.vue'),
    },
    props: {
      to: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        toUser: {},
        fromUser: {},
        msg: '',
        msgLabel: '回复',
        btnSend: {
          loading: false,
          width: 90,
          text: '发送'
        },
        btnMore: {
          loading: false,
          state: 0
        },
        params: null,
        items: [],
        loadStates: [
          'color: #2196F3;',
          'color: #2196F3;',
          'color: #a0aec0;',
          'color: #E53E3E;',
          'color: #a0aec0;'
        ],
        loadTexts: [
          '查看更多信息',
          '正在加载中...',
          '全部加载完成',
          '加载失败，重新刷新',
          '暂时没有信息'
        ],
        toOptions: {
          duration: 300,
          offset: 0,
          easing: 'easeInOutCubic',
        }
      }
    },
    watch: {
      to: {
        handler (val) {
          this.toUser = Object.assign({}, val)
          this.msgLabel = `回复${val.username}`
          this.configParams()
          this.loadRecords()
        },
        immediate: true
      }
    },
    created () {
      this.fromUser = user.info.get()

      // 绑定socket消息接收
      // socket.main.bind({
      //   name: 'private',
      //   trigger: this.receivedMsg
      // })

      EventBus.$on('messageChat', (data) => {
        console.log('messageChat message',data);
        this.receivedMsg(data)
      });

      // console.log('MessageChat created: 组件初始化完成', {
      //   fromUser: this.fromUser,
      //   socketBound: true
      // });
    },
    destroyed () {
      socket.main.unbind('private')
      EventBus.$off('messageChat');
      console.log('MessageChat destroyed: 组件销毁，socket解绑');
    },
    methods: {
      receivedMsg (msg) {
        console.log('receivedMsg: 收到新消息', { msg, currentItems: this.items.length });

        // 检查消息是否属于当前聊天
        if (msg && (msg.fromId === this.toUser.userId || msg.toId === this.toUser.userId)) {
          console.log('receivedMsg: 消息属于当前聊天，添加到列表');
          if(msg.from.userId === '1') {
            msg.from.avatar = msg.from.avatar || avatar;
          } else {
            msg.from.avatar = msg.from.avatar || avatar2;
          }
          this.items.push(msg);

          setTimeout(() => {
            app.emit('appbar_reddot', 0);
            EventBus.$emit('refreshReddot', 0);
          }, 500)

        } else {
          console.log('receivedMsg: 消息不属于当前聊天，忽略', {
            msgFromId: msg?.fromId,
            msgToId: msg?.toId,
            currentToId: this.toUser?.userId
          });
        }
      },
      goTo (msgId) {
        const me = this
        setTimeout(() => {
          const target = `#msg_${msgId}`
          // console.log({ target })
          me.$vuetify.goTo(target, me.toOptions)
        }, 500)
      },
      configParams () {
        const me = this
        console.log('configParams: 配置聊天参数', {
          toUserId: this.toUser.userId,
          currentParams: this.params
        });

        const executing = function () {
          console.log('configParams: 开始加载聊天记录');
        }

        const executed = function (res) {
          console.log('configParams: 聊天记录加载完成', {
            status: res.status,
            loadType: res.loadType,
            total: res.total,
            itemsCount: me.items.length
          });

          me.items.forEach(item => {
            item.from.avatar = item.from.avatar || avatar2;
          })

          if (res.status) {
            const cnt = me.items.length
            if (cnt > 0) {
              const last = me.items[cnt - 1]
              console.log('configParams: 滚动到最后一条消息', last);
              me.goTo(last.msgId)
            }
          } else {
            console.warn('configParams: 聊天记录加载失败', res);
          }
        }

        this.params = web.imMsg.getParams({
          chatUserId: this.toUser.userId,
          type: 'chat',
          reversed: true,
          caches: this.items,
          executing,
          executed
        })

        console.log('configParams: 创建聊天参数', this.params);
      },
      loadRecords (reload = true) {
        console.log('loadRecords: 开始加载聊天记录', {
          reload,
          params: this.params,
          currentItemsCount: this.items.length
        });

        if (!this.params) {
          console.error('loadRecords: 参数未配置，无法加载记录');
          return;
        }

        this.params.reload = reload
        api.httpx.getItems(this.params)
      },
      convertMessageItem (data) {
        const result = Object.assign({}, data)
        result.to = this.toUser
        result.from = this.fromUser

        if(result.from.userId === '1') {
          result.from.avatar = result.from.avatar || avatar;
        } else {
          result.from.avatar = result.from.avatar || avatar2;
        }

        const nowTime = dayjs()
        const crtTime = dayjs(data.createTime)
        const ms = nowTime.diff(crtTime)
        result.hintTime = api.comm.humanize(ms)
        result.shortTime = dayjs(data.createTime).format('MM-DD HH:mm')

        return result
      },
      addMessageToChat (data) {
        this.items.push(data)
      },
      onSend () {
        const me = this
        const content = api.comm.trim(this.msg)
        if (!content) {
          return
        }

        const data = {
          content,
          contentType: web.comm.MessageTypes.CHAT,
          type: web.comm.MessageTypes.CHAT,
          fromId: this.fromUser.userId,
          toId: this.to.userId
        }

        const executing = function () {
          me.btnSend.loading = true
        }

        const executed = function (res) {
          console.log('executed: 消息创建响应', { res });

          if (res.status) {
            const responseData = res.data
            console.log('executed: 消息创建成功', { responseData });

            const dst = me.convertMessageItem(responseData)
            console.log('executed: 转换后的消息', { dst });

            // 先清空输入框，提升用户体验
            me.msg = ''

            // 准备socket消息
            const socketMessage = JSON.stringify({
              ...responseData,
              createTime: null,
              updateTime: null,
              state: 'ready_send'
            })

            console.log('executed: 准备发送socket消息', { socketMessage });

            socket.main.send(socketMessage).then((_ev) => {
              console.log('executed: Socket发送成功', { _ev });
              me.addMessageToChat(dst)
              me.btnSend.loading = false
              console.log('消息发送成功')
            }).catch(_err => {
              console.warn('executed: Socket发送失败', { _err });
              me.btnSend.loading = false
              // 显示错误提示
              me.$notify({
                title: '发送失败',
                message: '消息发送失败，请重试',
                type: 'error'
              })
            })
          } else {
            console.warn('executed: 消息创建失败', { res });
            me.btnSend.loading = false
            // 显示错误提示
            me.$notify({
              title: '发送失败',
              message: '消息创建失败，请重试',
              type: 'error'
            })
          }
        }

        web.imMsg.create({
          data,
          executing,
          executed
        })
      }
    }
  }
</script>

<style>
  .msg-chat {
    display: flex;
    flex-direction: column;
    height: 610px;
  }
</style>
